import React from 'react'
import './BadgingTableHeader.scss';
import Button from '../../blocks/Button';
import { useTranslation } from 'react-i18next';
import { getDateLabelsForUsageWindow } from '../../blocks/Select/UsageWindow';

export default function BadgingTableHeader(props) {
  const {usageWindow} = props;
  const {value} = usageWindow;
  const isSchoolYearUsageWindow = value === "school_year"

  const {t, i18n} = useTranslation("badging_report")

  const {labelStart, labelEnd} = getDateLabelsForUsageWindow(usageWindow, i18n);

  let description = "";
  if (isSchoolYearUsageWindow) description = t('for the entire school year');
  else description = t("for_usage_week", {labelStart, labelEnd});

  return (
    <div className='badging-table-header'>
      <div className='badging-table-header-title'>{t("Our Students")}</div>
      <div className='badging-table-header-description'>
        <div>{t("Showing usage data")} {t("and badges earned")}</div>
        <div>{description}</div>
      </div>
      <Button style={{marginRight: 0}} onClick={props.onExportCsv} disabled={isSchoolYearUsageWindow}>{t("Export to CSV")}</Button>
    </div>
  )
}
